var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockLine = function SvgLockLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.8 10.2h.9a.9.9 0 0 1 .9.9v9a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9v-9a.9.9 0 0 1 .9-.9h.9v-.9a6.3 6.3 0 0 1 12.6 0zM6.2 12v7.2h12.6V12zm5.4 1.8h1.8v3.6h-1.8zm5.4-3.6v-.9a4.5 4.5 0 1 0-9 0v.9z"
  })));
};
export default SvgLockLine;